export enum ETipoRelatorioDespesasCentroCusto {
    Geral = 1,
    PorCategoria = 2,
}
